export default "__VITE_ASSET__f187f9bc__"